import { render } from "./NavbarProfileButton.vue?vue&type=template&id=deab2602&scoped=true"
import script from "./NavbarProfileButton.vue?vue&type=script&lang=js"
export * from "./NavbarProfileButton.vue?vue&type=script&lang=js"

import "./NavbarProfileButton.vue?vue&type=style&index=0&id=deab2602&scoped=true&lang=css"

import exportComponent from "/builds/Xpansiv/evo/DataPipeline/DataPipeline.Evolve.Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deab2602"]])

export default __exports__